import './App.css';
import Countdown from './Components/React-countdownTimer/Countdown';

function App() {
  return (
    <div className="App">
      <Countdown/>
    </div>
  );
}

export default App;
